import React from 'react';
import './Blog.css';
import BlogImage from '../../assets/blog/blog03.jpg';

export default function Blog() {
  return (
    <>
          <section id="blog">
              <div className="container">
                  <div className="blog_wrapper">
                      <div className="blog_col">
                          <h3>ENHANCING YOUR BUSINESS OPERATIONS WITH PROFESSIONAL SERVICES</h3>
                          <p>At our services blog, we offer insights into a wide range of business solutions including expert consulting, training, and top-tier secretarial services. We also provide convenient voucher sales for popular services such as Netflix, DSTV, and mobile international SIM cards. Join us as we guide you in optimizing your business processes and exploring new opportunities.</p>
                          <div className="btn_wrapper">
                              <a className="btn" href="/">Read More</a>
                          </div>
                      </div>
                      <div className="blog_col">
                          <div className="blog_image">
                              <img src={BlogImage} alt="Business Services" />
                          </div>
                      </div>
                  </div>
              </div>
          </section>
    </>
  )
}
